import { downLoadTemplate } from "@/router/downLoadTem"
export default {
    data() {
        return {
            /**
             * 通用tableList Mixins
             * 高级筛选显隐     draw
             * 分页参数         page
             * 搜索绑定参数     searchForm
             * 导出api          exportApi
             * 角色key值        peopleKey       默认managerUserName
             * 角色ID key值     peopleIDKey     默认managerUser
             * 部门key值        departmentKey   默认managerDeptName
             * 部门ID key值     departmentIDKey 默认managerDeptId
             * 
             * 查询列表数据方法名称 @function  queryTaleData 
             */
            searchForm: {},
            exportApi: '',
            peopleKey: 'managerUserName',
            peopleIDKey: 'managerUser',
            departmentKey: 'managerDeptName',
            departmentIDKey: 'managerDeptId',
            checkUserList: [],
            checkdepartment: [],
            page: {
                currentPage: 1,
                total: 0,
                layout: "total,pager,prev, next",
                background: false,
                pageSize: 10
            }            
        }
    },
    methods: {
        /**
         * 修改参数值
         * @param {Object} changeObject 如{peopleKey: string, departmentKey: string}
         */
        setCommonParams(changeObject) {
            for(let k in changeObject) {
                this.$data[k] = changeObject[k];
            }
        },

        searchChange(str,done) {
            this.queryTableData()
            done()
        },

        exportShow() {
            this.$refs.exportData.showModel();
        },        

        // 设置导出链接
        setExportUrl(api) {
            this.exportApi = api
        },

        cloudTages(data) {
            this.searchForm = data
        },

        saveData(row) {
            this.$refs.cloudtage.save(row);
        },        

        openFilter() {
            this.drawer = true
        },

        selectDeptClick() {
            this.$refs.selectdepartment.showModel();
        },

        selectPersonClick() {
            this.$refs.selectperson.showmode();
        },
        searchReset() {
            this.searchForm = {}
            this.page.currentPage = 1
            this.queryTableData()
        },

        searchResetScreen() {
            this.searchForm = {}
            this.page.currentPage = 1
            this.queryTableData()
        },

        // 高级筛选搜索
        filterSearch(str, done) {
            this.page.currentPage = 1
            this.queryTableData()
            done()
        },      

        setPeople(val) {
            this.checkUserList = val;
            // this.getVisitPeople();
            let people = val.map((item) => {
                return item.realName;
            });
            let ids = val.map((item) => {
                return item.id;
            });
            this.searchForm[this.peopleKey] = people.join(',')
            this.searchForm[this.peopleIDKey] = ids.join(',')          
        },

        setDepartment(data=[]) {
            this.checkdepartment = data;
            let titleList = data.map((item) => {
                return item.title || item.fullName;
            });
            let ids = data.map((item) => {
                return item.key;
            });

            this.searchForm[this.departmentKey] =  titleList.join(",")
            this.searchForm[this.departmentIDKey] = ids.join(",")
        },        
        
        exportDownload(value) {
            let page = this.page;
            let data = {
                export: value.code,
                auditState: 1
            };
            if (value.code == 1) {
                data = {
                ...data,
                firstNum: (page.currentPage - 1) * page.pageSize,
                num: page.pageSize,
                ...this.searchForm,
                };
            } else if (value.code == 2) {
                data = {
                ...data,
                ...this.searchForm,
                };
            }
            downLoadTemplate(this.exportApi, data, "GET").finally(() => {
                this.loading = false;
                this.$message({
                    type: "success",
                    message: "已下载",
                });
            });
        },
    }
}